import { IFloorDetails } from '@api'
import { ITreeNode } from '@blueprintjs/core'
import forEach from 'lodash/forEach'
import { LocationNodeType } from '../../components/LocationGroupTrees/components/renderTreeContents'

export type LocationTreeNodeT = ITreeNode<{
  nodeType: LocationNodeType
  nodePath: number[]
  floor?: IFloorDetails
  city?: {
    state: string
    name: string
  }
  building?: {
    name: string
    address: string
    city: string
    state: string
  }
}>

const forEachNode = (
  callback: (node: LocationTreeNodeT, parentCollection: LocationTreeNodeT[], index: number) => void,
  nodes?: LocationTreeNodeT[]
) => {
  if (!nodes) {
    return
  }

  forEach<LocationTreeNodeT>(nodes, (node, key) => {
    if (!node) {
      return
    }

    callback(node, nodes, key)
    forEachNode(callback, node.childNodes)
  })
}

export default forEachNode
